/**
 * Page-session memory for the delivered-attachment claim (InheritedMessageView). It lives outside
 * the component so a remount or re-render can't re-fire a claim that already ran this session.
 *
 * - A claim that finished (COMPLETE / NOTHING_TO_COPY), or can't succeed this session
 *   (WRONG_TOKEN_TYPE), is never sent again for that message.
 * - REAUTH_REQUIRED stops every claim for the rest of the session: the token is no longer accepted,
 *   and the next sign-in starts a fresh session.
 * - A claim that FAILED, threw, or ran out of retries is released, so the next open of the message
 *   tries again (plan §7.4). Downloads never depend on it.
 */
const inFlightOrSettled = new Set<string>();
let reauthRequired = false;

export const attachmentClaimSession = {
  /** Reserves the message for one claim; false if it already ran or is running, or after REAUTH_REQUIRED. */
  tryBegin(deliveredMessageId: string): boolean {
    if (reauthRequired || inFlightOrSettled.has(deliveredMessageId)) return false;
    inFlightOrSettled.add(deliveredMessageId);
    return true;
  },
  /** Lets a later open retry this message. */
  release(deliveredMessageId: string): void {
    inFlightOrSettled.delete(deliveredMessageId);
  },
  markReauthRequired(): void {
    reauthRequired = true;
  },
  /** Tests only. */
  reset(): void {
    inFlightOrSettled.clear();
    reauthRequired = false;
  },
};
